import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BookAppointmentImage from "./../../assets/images/registration-page-image-02.png";
import axios from "axios";
import {useNavigate, useLocation } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';


const BookAppointment = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const serviceDescription = location.state?.servicedescription || ""; 

  const [consultationTypes, setConsultationTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [showFetchErrorModal, setShowFetchErrorModal] = useState(false);
  const [fetchErrorMessage, setFetchErrorMessage] = useState("");

   // Get ServiceDescription and Contract from Redux store
   const contract = useSelector((state) => state.userData);
   const navigate = useNavigate();
   const ssoData = useSelector((state) => state.sso.ssoUserData);
   const isHighmarkPortal = ssoData?.Portal === "Highmark";
   const [loading, setLoading] = useState(true);
   const advocateConsultType = location.state?.advocateConsultType || ""; 

  useEffect(() => {
    const token = localStorage.getItem('AccessToken');
    
    // Function to fetch data from the API
    const fetchConsultationTypes = async () => {
      setLoading(true);
      try {
        const response = await axios.post(Endpoints.fetchConsultationTypes,{
          _params: JSON.stringify({
            ServiceDescription: serviceDescription,
            Contract: contract.userData.ContractIdentified,
            EmailID: contract.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            AdvocateConsultType: advocateConsultType
          })},
          {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

        if (response.data) {
          setConsultationTypes(response.data); // Assuming the response has the list of consultation types
          if (!Array.isArray(response.data) && response.data.length ===0) {
              setFetchErrorMessage("Failed to fetch consults, try launching the application again");
              setShowFetchErrorModal(true);
          }
        } else {
          console.error(response.statusText);
          setFetchErrorMessage("Failed to fetch consults, try launching the application again");
          setShowFetchErrorModal(true);
        }
      } catch (error) {
        console.error(error);
        setFetchErrorMessage("Failed to fetch consults, try launching the application again");
        setShowFetchErrorModal(true);
      } finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
    };

     // Only call if token exists
  if (token) {
    fetchConsultationTypes();
  } else {
    setLoading(false);
    setFetchErrorMessage("Failed to fetch consults, try launching the application again");
    setShowFetchErrorModal(true);
  }

  }, []);
  const handleTypeClick = (type) => {
    if (type === "Behavioral Health") {
      setSelectedType(type);
      if (!isHighmarkPortal) {
        setModalMessage(t("bookappointmentmodal"));
        setShowModal(true);
      } else {
        navigate("/phone-video-appointment", { state: { selectedType: type } });
      }
    }  else if (type === "Nurse") {
      // If the type is Nurse, navigate to phone-video-appointment with CalendarType: Primary
      navigate("/phone-video-appointment", { 
        state: { selectedType: type, CalendarType: "Primary" } 
      });
    }else {
      navigate("/phone-video-appointment", { state: { selectedType: type } });
    }
  };
  const confirmNavigation = () => {
    setShowModal(false);
    navigate("/phone-video-appointment", { state: { selectedType } });
  };
  const handleBackClick = () => {
    if (location.state?.fromWelcomeForm) {
      navigate("/home"); // Redirect to home if coming from WelcomeForm
  } else {
      navigate(-1); // Go back to the previous page otherwise
  }
  };
  const handleFetchErrorOkay = () => {
  setShowFetchErrorModal(false);
  const ssoFullUrl = sessionStorage.getItem("ssofullUrl");
  if (ssoFullUrl) {
    window.location.href = ssoFullUrl;
  }
};
if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

    return <>
      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>              
            </span>
          </button>       
          <h2 className="page-heading">{t('BookanAppointment')}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">{t('BookanAppointment')}</h2>
        </div>
      }

    <div className="col-md-12 schedules-wrapper">
      {consultationTypes.length > 0 ? (
          consultationTypes.map((type, index) => (
            <div
                key={index}
                className="schedule-block-new highmark-option"
                onClick={() => handleTypeClick(type)}
              >
              <span className="schedule-block-left-logo"></span>
              <span className="schedule-block-text"> {t('viewAdvocateSchedule', { type: type === "Nurse" ? "Fertility Nurse" : type })}</span>
            </div>
          ))
        ) : (
            // Load dummy links when no API response or empty consultationTypes
        <>
           <p>Loading consultation types...</p>
        </>
      )}
    </div>

    <div className="col-md-6" style={{display: "none"}}>
    {consultationTypes.length > 0 ? (
          consultationTypes.map((type, index) => (
            <div
              key={index}
              className="schedule-block"
              onClick={() => handleTypeClick(type)}
            >
              <span className="schedule-block-left-logo"></span>
              <span> {t('viewAdvocateSchedule', { type: type === "Nurse" ? "Fertility Nurse" : type })}</span>
            </div>
          ))
        ) : (
            // Load dummy links when no API response or empty consultationTypes
        <>
         <p>{t('loadconsultation')}</p>
        </>
        )}
        </div>
        <div className="col-md-6 fertility-tracker-right-section" style={{display: "none"}}>
          <div className="schedule-block-right-image-wrapper">
          <img src={BookAppointmentImage} className="schedule-block-right-image" alt="" />
          </div>
        </div>

          {/* Show ErrorModal only if NOT Highmark portal */}
          {!isHighmarkPortal && (
            <ErrorModal
            show={showModal}
            message={modalMessage}
            onClose={() => setShowModal(false)}
            isBehavioralHealthSelected={true}
            onOkay={confirmNavigation}
            />
          )}
          
      <ErrorModal
        show={showFetchErrorModal}
        message={fetchErrorMessage}
        onClose={() => setShowFetchErrorModal(false)}
        isOkay={true}
        onOkay={handleFetchErrorOkay}
      />
    </>
  };
  
  export default BookAppointment; 